import type { DirectoryTreeNode } from './types';

export type DirectorySearchCriterion = 'module' | 'folder' | 'title' | 'prefix';

/**
 * Item vinculado — documento, registro ou matriz. Módulo e pasta não entram na busca por prefixo
 * nem por título. Documento chega da API com `kind: 'document'`; deixá-lo de fora era o que fazia
 * a busca por prefixo e por título ignorar documento na árvore real.
 */
export function isDirectorySearchLeaf(node: DirectoryTreeNode): boolean {
  return node.kind !== 'module' && node.kind !== 'folder';
}

export function nodeMatchesSearchCriterion(
  node: DirectoryTreeNode,
  term: string,
  criterion: DirectorySearchCriterion
): boolean {
  const lowerTerm = term.toLowerCase();

  if (criterion === 'module') {
    return node.kind === 'module' && node.name.toLowerCase().includes(lowerTerm);
  }

  if (criterion === 'folder') {
    return node.kind === 'folder' && node.name.toLowerCase().includes(lowerTerm);
  }

  if (!isDirectorySearchLeaf(node)) {
    return false;
  }

  if (criterion === 'title') {
    // O nó já guarda título e prefixo separados; o rótulo composto entra também para quem digita
    // "PQ01 - Manual" inteiro.
    const title = node.title ?? node.name;
    return (
      title.toLowerCase().includes(lowerTerm) || node.name.toLowerCase().includes(lowerTerm)
    );
  }

  if (criterion === 'prefix') {
    return node.prefix?.toLowerCase().includes(lowerTerm) ?? false;
  }

  return false;
}
